module.exports = __webpack_public_path__ + "static/media/008_Complete Template.bee14725.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/008_Complete Template.png
// module id = 375
// module chunks = 0